<template>
  <section id="infoCalls">
    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="rangeDialogActive"
      :active="rangeDialogActive"
      :module="moduleType"
      :queues="queueList"
      @dialog:change="eventdialog"
    ></RangeDateDialog>

    <v-card class="shadow-1 mt-5">
      <v-tabs v-model="tab" dark background-color="secondary lighten-1" hide-slider grow>
        <v-tab
          v-for="(item, index) in tabHeaders"
          :key="index"
          @click="getOverviewInfo(index)"
        >
          <v-slide-x-transition>
            <v-icon left v-if="tab === index">mdi-check-circle-outline</v-icon>
          </v-slide-x-transition>
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabHeaders" :key="item">
          <v-card flat>
            <!-- Tabla -->
            <v-container>
              <v-skeleton-loader v-if="isLoading" type="table"> </v-skeleton-loader>

              <v-row v-else dense justify="end">
                <v-col cols="12" md="6">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Nombre</th>
                          <th class="text-right">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in overviewData"
                          :style="item.type ? 'cursor:pointer' : ''"
                          @click="index <= 2 && detailsDialog(item.type)"
                          :key="item.name"
                        >
                          <td>{{ item.name }}</td>
                          <td
                            class="text-right"
                            v-if="['Hablado', 'Duración Promedio'].includes(item.name)"
                          >
                            {{ item.total | secondsToTimeFormat }}
                          </td>
                          <td class="text-right" v-else>
                            {{ item.total }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>

                <v-col cols="12" md="6">
                  <!-- tabs de las graficas -->
                  <v-card outlined>
                    <v-card flat v-if="!isLoading">
                      <apexchart
                        ref="chart3Queue"
                        type="donut"
                        :options="optionsDonut"
                        :series="serieDonut"
                      ></apexchart>
                    </v-card>

                    <v-skeleton-loader
                      v-else
                      transition="scale-transition"
                      class="mx-auto"
                      type="image"
                    >
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog v-if="activeDialog" v-model="activeDialog">
      <v-card>
        <v-card-text>
          <v-row dense justify="end" class="white">
            <v-col cols="12" v-if="search === ''">
              <vuescroll
                :ops="{
                  bar: {
                    background: '#bacfcec0',
                    keepShow: true,
                  },
                }"
              >
                <v-skeleton-loader v-if="tableIsLoading" type="table">
                </v-skeleton-loader>
                <v-data-table
                  v-else
                  :headers="tableHeaders[2]"
                  :items="tableItems"
                  class="elevation-0"
                  :items-per-page="15"
                  :search="search"
                  disable-pagination
                  hide-default-footer
                >
                  <!-- Items for table 2 -->
                  <template v-slot:[`item.spoken`]="{ item }">
                    <span>
                      {{ item.csr[0].csr[0].spoken | secondsToTimeFormat }}
                    </span>
                  </template>
                  <template v-slot:[`item.hang`]="{ item }">
                    <span>
                      {{ item.csr[0].csr[0].hang }}
                    </span>
                  </template>
                  <!-- Items for table 2 and 3 -->
                  <template v-slot:[`item.numero`]="{ item }">
                    <span>{{ item.csr[0].numero }}</span>
                  </template>
                  <template v-slot:[`item.tiempoespera`]="{ item }">
                    <span>
                      {{ item.csr[0].csr[0].tiempoespera | secondsToTimeFormat }}
                    </span>
                  </template>
                  <!-- Items for all -->
                  <template v-slot:[`item.fecha`]="{ item }">
                    <span>{{ normalizeDate(item.timestamp) }}</span>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <span>
                      <v-btn class="rounded-lg" @click="showCDR(item)">
                        Ver Detalles
                      </v-btn>
                    </span>
                  </template>
                </v-data-table>
              </vuescroll>
            </v-col>
            <v-col cols="12" v-else>
              <span></span>
              <vuescroll
                :ops="{
                  bar: {
                    background: '#bacfcec0',
                    keepShow: true,
                  },
                }"
              >
                <v-data-table
                  :headers="headers"
                  :items="CDRInfo"
                  class="elevation-0"
                  :items-per-page="50"
                  :search="search"
                  hide-default-footer
                >
                  <template v-slot:[`item.hour`]="{ item }">
                    <span>{{ item.fecha | getHourFormat }}</span>
                  </template>

                  <template v-slot:[`item.duracion`]="{ item }">
                    <span>
                      {{ item.duracion | secondsToTimeFormat }}
                    </span>
                  </template>

                  <template v-slot:[`item.hablado`]="{ item }">
                    <span>
                      {{ item.hablado | secondsToTimeFormat }}
                    </span>
                  </template>

                  <template v-slot:[`item.estado`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip color="transparent" small v-bind="attrs" v-on="on">
                          <v-icon left small :color="getSpanishState(item.estado).color"
                            >{{ getSpanishState(item.estado).icon }}
                          </v-icon>
                          {{ getSpanishState(item.estado).text }}
                        </v-chip>
                      </template>
                      <span>{{ "Top tooltip" }}</span>
                    </v-tooltip>
                  </template>

                  <template v-slot:[`item.recordingfile`]="{ item }">
                    <div class="pt-2 pb-1" v-if="item.recordingfile">
                      <v-icon>mdi-pLay</v-icon>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <audio
                            :src="'http://' + webURL + item.recordingfile"
                            controls
                            preload="none"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <p>Tu navegador no implementa el elemento audio.</p>
                          </audio>
                        </template>
                        <span>{{ item.recordingfile }}</span>
                      </v-tooltip>
                    </div>

                    <span class="caption grey--text" v-else>No disponible</span>
                  </template>
                </v-data-table>
              </vuescroll>
            </v-col>

            <v-col cols="auto">
              <v-pagination
                v-if="!tableIsLoading"
                circle
                :total-visible="7"
                color="primary"
                v-model="currentPage"
                :length="totalPages"
                @input="handlePageChange"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="white">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="activeDialog = false"
            >
              Cancelar
            </v-btn>
          </v-hover>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CDR Dialog -->
    <v-dialog v-model="cdrDialog" max-width="1000px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="cdrDialogTableHeaders"
                :items="cdrDialogData"
                class="elevation-0"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:[`item.hour`]="{ item }">
                  <span>{{ item.fecha | getHourFormat }}</span>
                </template>

                <template v-slot:[`item.duracion`]="{ item }">
                  <span>
                    {{ item.duracion | secondsToTimeFormat }}
                  </span>
                </template>

                <template v-slot:[`item.hablado`]="{ item }">
                  <span>
                    {{ item.hablado | secondsToTimeFormat }}
                  </span>
                </template>

                <template v-slot:[`item.estado`]="{ item }">
                  <v-chip color="transparent" small>
                    <v-icon left small :color="getSpanishState(item.estado).color"
                      >{{ getSpanishState(item.estado).icon }}
                    </v-icon>
                    {{ getSpanishState(item.estado).text }}
                  </v-chip>
                </template>

                <template v-if="false" v-slot:[`item.recordingfile`]="{ item }">
                  <div class="pt-2 pb-1" v-if="item.recordingfile">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <audio controls preload="none" v-bind="attrs" v-on="on">
                          <source
                            :src="
                              'https://' +
                                webURL +
                                recordingPathGenerator(item.recordingfile)
                            "
                            type="audio/wav"
                          />

                          <source
                            :src="
                              'https://' +
                                webURL +
                                recordingPathGenerator(item.recordingfile, true)
                            "
                            type="audio/mpeg"
                          />
                          <p>
                            Tu navegador no implementa el elemento audio.
                          </p>
                        </audio>
                      </template>
                      <span>{{ item.recordingfile }}</span>
                    </v-tooltip>
                  </div>
                  <span class="caption grey--text" v-else>No disponible</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="cdrDialog = false"
            >
              Cancelar
            </v-btn>
          </v-hover>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
/**
 * @author Abraham Correa
 */
import vuescroll from "vuescroll";
import axios from "axios";
import moment from "moment";

import RangeDateDialog from "../../DatePickers/DateRangePicker";
import recordingPathGenerator from "@/components/Utils/recordingPathGenerator";

export default {
  name: "ActivityOverview",
  inject: ["theme"],
  components: {
    RangeDateDialog,
    vuescroll,
  },
  props: {
    type: {
      type: String,
    },
    moduleType: {
      type: String,
    },
  },
  data() {
    return {
      recordingPathGenerator: recordingPathGenerator,
      request: "",
      infoUrl: `${process.env.VUE_APP_ROOTAPI}`,
      accessToken: localStorage.getItem("token"),
      rangeDialogActive: false,
      tab: null,
      tabHeaders: ["Diario", "Personalizado"],
      innerTab: null,
      isLoading: false,
      tableIsLoading: false,
      search: "",
      customSearchInfo: null,
      axiosInstance: null,
      dataUrl: {
        queue: ["queue_day"],
        pauses: ["pauses_made", "pauses_made_custom"],
      },
      customParameters: {},
      tableHeaders: {
        1: [
          {
            text: "Cola",
            value: "qname",
            width: "30%",
          },
          {
            text: "Número",
            value: "info2",
            width: "30%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "25%",
          },
          {
            text: "Acción",
            value: "action",
            width: "15%",
          },
        ],
        2: [
          {
            text: "Cola",
            value: "qname",
            width: "20%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "20%",
          },
          {
            text: "Agente",
            value: "agent",
            width: "20%",
          },
          {
            text: "Número",
            value: "numero",
            width: "13%",
          },
          {
            text: "Colgado",
            value: "hang",
            width: "13%",
          },
          {
            text: "Tiempo de Espera",
            value: "tiempoespera",
            width: "13%",
          },
          {
            text: "Hablado",
            value: "spoken",
            width: "13%",
          },
          {
            text: "Acción",
            value: "action",
            width: "13%",
          },
        ],
        3: [
          {
            text: "Nombre",
            value: "qname",
            width: "20%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "20%",
          },
          {
            text: "Tiempo de Espera",
            value: "tiempoespera",
            width: "20%",
          },
          {
            text: "Número",
            value: "numero",
            width: "13%",
          },
          {
            text: "Acción",
            value: "action",
            width: "13%",
          },
        ],
      },
      actualHeader: 1,
      tableItems: [],
      currentPage: 1,
      totalPages: null,
      queueList: [],
      options: {},
      render: false,
      webURL: null,
      headers: [],
      activeDialog: false,
      cdrDialog: false,
      cdrDialogData: [],
      cdrDialogTableHeaders: [
        { text: "Origen", value: "src", width: "10%" },
        {
          text: "Destino",
          value: "dst",
          width: "15%",
        },
        {
          text: "Duración",
          align: "right",
          value: "duracion",
          width: "15%",
          align: "center",
        },
        {
          text: "Hablado",
          align: "right",
          value: "hablado",
          width: "15%",
          align: "center",
        },
        {
          text: "Estado",
          value: "estado",
          width: "15%",
        },
        // {
        //   text: "Grabación",
        //   align: "center",
        //   value: "recordingfile",
        //   filterable: false,
        //   width: "25%",
        // },
      ],
      // Simple Table data
      overviewData: [
        {
          name: "Llamadas Atendidas",
          total: 0,
          type: 1,
          key: "contestadas",
        },
        {
          name: "Colgado Usuario",
          total: 0,
          type: 2,
          key: "colgadoLlama",
        },
        {
          name: "Colgado Agente",
          total: 0,
          type: 3,
          key: "colgadoAgente",
        },
        {
          name: "Llamadas perdidas",
          total: 0,
          key: "noContestadas",
          //   suffix: "seg",
        },
        {
          name: "Duración Promedio",
          total: 0,
          key: "esperando",
          // suffix: "seg",
        },
        {
          name: "Hablado",
          total: 0,
          key: "hablado",
          // suffix: "seg",
        },
        {
          name: "Transferencia",
          total: 0,
          key: "transfe",
          //   suffix: "seg",
        },
      ],
      //Graph data
      optionsDonut: {
        chart: {
          type: "donut",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        labels: ["Usuario", "Agente"],
      },
      serieDonut: [0, 0],
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },
  },

  created() {
    this.axiosInstance = axios.create({
      baseURL: this.infoUrl,
      headers: {
        Authorization: `Bearer ${this.accessToken}`,
      },
    });
    this.getOverviewInfo(0);
  },

  methods: {
    showCDR(item) {
      // console.log(item);
      this.cdrDialogData = [item.cdr];
      this.cdrDialog = true;
    },
    /**
     * Busca los datos de las llamadas cuando abre la vista, llena el grafico y la tabla
     * @param {Number} index - Indice de la tab, entre 1 = diario y 2 = personalizado
     */
    async getOverviewInfo(index) {
      this.isLoading = true;
      if (index === 1) {
        try {
          const { data } = await this.axiosInstance.get("/agents/sumary/queueName");
          this.queueList = data;
          this.rangeDialogActive = true;
        } catch (err) {
          this.tab = 0;
          this.isLoading = false;
          return;
        }
      } else {
        try {
          const { data } = await this.axiosInstance.get(`/agents/sumary/queue_day`);
          this.overviewData = this.overviewData.map((el) => ({
            ...el,
            total: data[el.key],
          }));
          this.serieDonut = [Number(data.colgadoLlama), Number(data.colgadoAgente)];
        } catch (errors) {
          // console.error(errors);
          if (errors.response.status === 401) {
            this.$snotify.error("Su sesion ha finalizado.", "Error");
            this.$store.dispatch("passport/RESET_AUTH");
            this.$router.push({ name: "login" });
            return;
          }
          this.$snotify.error("Hubo un error en la consulta", "Error");
        }
        this.isLoading = false;
      }
    },

    async detailsDialog(type) {
      this.activeDialog = true;
      this.actualHeader = type;
      await this.getInfo(type, 1);
    },

    /**
     * Busca los datos de los detalles de la tabla
     * @param {Number} type - Especifica el tipo de tabla que se va a mostrar
     */
    async getInfo(type, page) {
      this.tableIsLoading = true;
      this.tableItems = [];
      const payload = this.tab === 0 ? { type } : { ...this.customParameters, type };
      const path =
        this.tab === 0
          ? `/agents/sumary/queue_day_details?page=${page}`
          : `/reports/tail_personality_details?page=${page}`;
      try {
        const { data } = await this.axiosInstance.post(path, payload);
        this.currentPage = data.data.current_page;
        this.totalPages = data.data.last_page;
        this.tableItems = data.data.data.map((el, index) => ({
          ...el,
          _id: el.id,
          id: index,
        }));
        this.path = data.path;
        this.customParameters = { type, ...this.customParameters };
      } catch (errors) {
        if (errors.response.status === 401) {
          this.$snotify.error("Su sesion ha finalizado.", "Error");
          this.$store.dispatch("passport/RESET_AUTH");
          this.$router.push({ name: "login" });
          return;
        }
        // console.log(errors);
      }
      this.tableIsLoading = false;
    },

    /**
     * Cambia la pagina actual
     * @param {string} index - Indice de la tabla mostrada
     * @param {string} table - Nombre de la tabla mostrada
     */
    async handlePageChange(index) {
      this.tableIsLoading = true;
      const path = `/reports/tail_personality_details?page=${index}`;
      try {
        const { data } =
          this.tab === 1
            ? await this.axiosInstance.post(path, this.customParameters)
            : await this.axiosInstance.post(
                `/agents/sumary/queue_day_details?page=${index}`,
                this.customParameters
              );
        this.tableItems = data.data.data.map((el, index) => ({
          ...el,
          _id: el.id,
          id: index,
        }));
      } catch (err) {
        console.log(err);
      }
      this.tableIsLoading = false;
    },

    /**
     * [Obtener estado en español]
     * @param {string} state [Estado de la llamada]
     */
    getSpanishState(state) {
      if (state == "ANSWERED") {
        return {
          text: "Usuario",
          color: "success",
          icon: "mdi-phone-outline",
        };
      } else {
        return {
          text: "Agente",
          color: "error",
          icon: "mdi-call-missed",
        };
      }
    },

    async eventdialog(data, parameters) {
      this.rangeDialogActive = false;
      const payload = {
        value: parameters,
      };
      if (data !== "cerrar") {
        this.isLoading = true;
        try {
          const { data } = await this.axiosInstance.post(
            "/agents/sumary/queue_custome_resumen",
            payload
          );
          // console.log("data", data);
          this.overviewData = this.overviewData.map((el) => ({
            ...el,
            total: data[el.key],
          }));
          this.serieDonut = [data.colgadoLlama, data.colgadoAgente];
          this.customParameters = payload;
        } catch (err) {
          this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
          // console.log(err);
          this.tab = 0;
          this.getInfo(0);
        }
        this.isLoading = false;
      } else {
        this.tab = 0;
        this.getOverviewInfo(0);
      }
      return;
    },

    normalizeDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}

audio {
  height: 35px !important;
}
</style>
